import { useBreakpointValue } from "@gluestack-style/react";
import { ClientInfoSectionProps } from "@repo/core/components/receipt/sections/ClientInfoSection/types";
import { LimitsAvailableSectionProps } from "@repo/core/components/receipt/sections/LimitsAvailableSection/types";
import { StoreInfoSectionProps } from "@repo/core/components/receipt/sections/StoreInfoSection/types";
import { useGeneratePdf } from "@repo/core/hooks/useGeneratePdf";
import { useNavigation } from "@repo/core/hooks/useNavigation";
import { useRouteParams } from "@repo/core/hooks/useRouteParams";
import { ROUTES } from "@repo/core/routes";
import { ConsultLimitsTerminalResponseDTO } from "@repo/core/services/entities/Terminal";

export const LimitsReceiptController = () => {
  const isMobile = useBreakpointValue({ base: true, md: false });
  const { viewRef, handleCaptureAndGeneratePDF, isLoading } = useGeneratePdf({
    documentTitle: `WayUP - Consulta Limites Disponíveis - ${Date.now()}`
  });
  const { back, replace } = useNavigation();
  const state = useRouteParams();

  const limitsResponse = state as ConsultLimitsTerminalResponseDTO;

  const handleGoToSales = () => {
    replace(ROUTES.sales);
  };

  const limitsInfo: LimitsAvailableSectionProps = {
    limiteDisponivelCompras: limitsResponse?.limiteDisponivelCompras || "0,00",
    limiteDisponivelParcelado:
      limitsResponse?.limiteDisponivelParcelado || "0,00",
    limiteDisponivelParceladoMes:
      limitsResponse?.limiteDisponivelParceladoMes || "0,00",
    limiteDisponivelSaques: limitsResponse?.limiteDisponivelSaques || "0,00",
    pontosDisponiveis: limitsResponse?.pontosDisponiveis || "0,00"
  };

  const clientInfo: ClientInfoSectionProps = {
    title: "Cliente",
    icon: "circle-user",
    name: limitsResponse?.cliente,
    fone: limitsResponse?.foneCliente
  };

  const storeInfo: StoreInfoSectionProps = {
    title: "Dados Gerais",
    icon: "list",
    name: limitsResponse?.lojista,
    address: limitsResponse?.endereco,
    cnpj: limitsResponse?.cnpj,
    phone: limitsResponse?.fone,
    date: limitsResponse.data,
    time: limitsResponse.hora
  };
  return {
    back,
    isMobile,
    handleGoToSales,
    limitsInfo,
    clientInfo,
    storeInfo,
    viewRef,
    handleCaptureAndGeneratePDF,
    isLoading
  };
};
